import script from "./DetailsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailsCard.vue?vue&type=script&setup=true&lang=js"

import "./DetailsCard.vue?vue&type=style&index=0&id=e145c978&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e145c978"]])

export default __exports__